import { DeepPath, GeneratedObject, GeneratedObjectTree, I18n, NestedObject } from '../nested-object';

export class TranslationFactory {
  public static getTranslations<T extends NestedObject, P extends DeepPath<T> | null>(translations: T): GeneratedObjectTree<T, P> {
    const generatedKeyPaths = I18n.generateKeyPath(translations);
    return generatedKeyPaths as GeneratedObjectTree<T, P>;
  }

  public static getFeatureTranslations<T extends NestedObject, P extends DeepPath<T> | null>(
    translations: T,
    featurePath: P,
  ): GeneratedObjectTree<T, P> {
    const allTranslations = TranslationFactory.getTranslations<T, P>(translations);

    if (!featurePath) {
      return allTranslations;
    }

    return featurePath.split('.').reduce<GeneratedObject<T>>((obj, key) => {
      return obj[key] as unknown as GeneratedObject<T>;
    }, allTranslations as GeneratedObject<T>) as GeneratedObjectTree<T, P>;
  }
}
